import React, { useState } from 'react';
import axios from 'axios';

const UploadPDF = () => {
    const [file, setFile] = useState(null);

    const handleUpload = async () => {
        const formData = new FormData();
        formData.append('pdf', file);

        const res = await axios.post("http://localhost:3001/from-react", formData, {
            responseType: 'blob',
        });

        // Download file
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'converted.docx');
        document.body.appendChild(link);
        link.click();
    };

    return (
        <div>
            <input type="file" onChange={(e) => setFile(e.target.files[0])} />
            <button onClick={handleUpload}>Convert PDF to DOCX</button>
        </div>
    );
};

export default UploadPDF;
